import { BaseFetch } from "../main-model"
export default class EduDevPlanModel extends BaseFetch {
    getEduDevPlanBy = (data) =>
    this.authFetch({
      url: "edu-dev-plan/getEduDevPlanBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getEduDevPlanById = (data) =>
    this.authFetch({
      url: "edu-dev-plan/getEduDevPlanById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateEduDevPlanById = (data) =>
    this.authFetch({
      url: "edu-dev-plan/updateEduDevPlanById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertEduDevPlan = (data) =>
    this.authFetch({
      url: "edu-dev-plan/insertEduDevPlan",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteEduDevPlanById = (data) =>
    this.authFetch({
      url: "edu-dev-plan/deleteEduDevPlanById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
